import './set_refuse_reason.css'
import React, { useState } from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import CancelIcon from '@mui/icons-material/Cancel';
import SendIcon from '@mui/icons-material/Send';
import Backdrop from '@mui/material/Backdrop';
import swal from 'sweetalert';
import CircularProgress from '@mui/material/CircularProgress';
import { change_order_state_depend_on_purchase_request} from "../../../../../../services/supplier_service";


function Set_refuse_reason_inner_delivery({open_reason_modal,setOpen_reason_modal,id_supplier,request_code}){


  const [errorText,setErrorText] = useState("");
  const [waiting, setWaiting] = useState(false);

  const [reason,setReason]=useState('');
  let user=JSON.parse(localStorage.getItem('user-info'))
  const id_service=user.id;


  const submitRefuseReason = async () => {
    if (!reason.trim()) {
      setErrorText("Veuillez entrer un motif de rejet.");
      return;
    }
  
    setWaiting(true);
  
    swal({
      title: "La commande est non conforme",
      text: "Voulez-vous confirmer la non-conformité de la commande ?",
      icon: "warning",
      buttons: true,
    }).then(async (isConfirm) => {
      if (isConfirm) {
        try {
        console.log("User confirmed the non-conformity of the order");

        const now = new Date();
        const conformity_date = now.toLocaleString("sv-SE", { timeZone: "UTC" }).replace("T", " ");


        const requestData = {
            request_code: request_code,
            id_supplier:id_supplier,
            performed_by:id_service,
            conformity_date: conformity_date,
            state: "non conforme", 
            non_conformity_reason: reason,
        };

        const response = await change_order_state_depend_on_purchase_request(requestData);

        console.log(" Response:", response);

        swal("Commande non conforme enregistrée!", "Motif: " + reason, "success");
        setOpen_reason_modal(false);
        

        } catch (error) {
        console.error(" Error updating conformity status:", error.response);
        }
    }
    });

};

    

    return (
    <Dialog className="set_refuse_raison_container" fullWidth={true} maxWidth={'md'} open={open_reason_modal!=null?true:false} onClose={()=>setOpen_reason_modal(null)} aria-labelledby="form-dialog-title" >
        <DialogTitle id="form-dialog-title">Motif du rejet</DialogTitle>
        <DialogContent>
        <div>
                {
                    errorText == "" 
                    ?<></>
                    :<p className={errorText ? "error" : "valid-champ"}>
                            {errorText}
                        </p>
                }

              <div style={{width:"100%",marginTop:"5px"}} >
              <TextField
                  id="outlined-multiline-flexible"
                  label="Motif"
                  variant='outlined'
                  multiline
                  minRows={4}
                  value={reason}
                  onChange={(e)=>setReason(e.target.value)} 
                  style={{width:"100%"}}
                />
              </div>
          </div>


          <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={waiting}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
          
     </DialogContent>
        <DialogActions>
          <div className='dialogBottom'>
            <div>
                {
                    errorText === ""
                    ?<></>
                    :<p className={errorText ? "col-md-10 error" : "col-md-10 valid-champ"}>
                            {errorText}
                        </p>
                }
            </div>
            <div>
              <Button variant="contained" className={waiting?"submit_but cancel_but disabled_button":"submit_but cancel_but"} startIcon={<CancelIcon className="my_icon" />} onClick={()=>setOpen_reason_modal(false)} >
                  Annuler
              </Button>
              <Button variant="contained" className={waiting?"submit_but valide_but disabled_button":"submit_but valide_but"} startIcon={<SendIcon className="my_icon" />} onClick={submitRefuseReason} >
                  Envoyer
              </Button> 
            </div>
          </div>
        </DialogActions>

      </Dialog>
    )
}

export default Set_refuse_reason_inner_delivery
